<template>
  <v-container>
    <v-container fluid class="pa-3 lighten-5">
      <v-row align="stretch">
        <!-- LEFT SIDEBAR: LVIS Categories from Firestore -->
        <v-col cols="12" sm="2" v-if="activeTab === 0">
          <v-card class="category-box pa-2 h-100" elevation="2">
            <p class="sidebar-title">LVIS Categories</p>
            <hr class="divider">
            <div class="category-container">
              <v-row dense>
                <v-col
                  v-for="(category, index) in categories"
                  :key="index"
                  cols="12"
                >
                  <span
                    :class="{ 'selected-category': selectedCategory === category }"
                    class="category-text"
                    @click="filterByCategory(category)"
                  >
                    {{ category }}
                  </span>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
        
        <v-col cols="12" sm="2" v-else>

        </v-col>

        <!-- MAIN CONTENT -->
        <v-col cols="12" sm="10">
          <v-card class="tabs-container" elevation="3">
            <v-tabs v-model="activeTab" background-color="rgba(125, 128, 218, 0.05)" color="primary" center-active grow>
              <v-tab v-for="(tab, index) in tabs" :key="index" class="custom-tab">
                {{ tab.name }}
              </v-tab>
            </v-tabs>
          </v-card>

          <!-- SEARCH BAR -->
          <v-row justify="space-between" class="mt-3 search-bar">
            <v-col cols="auto">
              <h2 class="page-title gradient-text">{{ currentTabName }}</h2>
            </v-col>
            <v-col cols="auto">
              <v-text-field
                v-model="searchQuery"
                :loading="loading"
                prepend-inner-icon="mdi-magnify"
                density="compact"
                label="Search"
                variant="outlined"
                hide-details
                clearable
                @input="applyFilters"
                style="padding-right: 3%; width: 40vh;"
              ></v-text-field>
            </v-col>
          </v-row>
          <hr style="margin-top:1%; margin-left: 1%; margin-right: 1%;">

          <!-- TAB CONTENT -->
          <v-tabs-items v-model="activeTab">

            <v-tab-item>
              <v-container class="main-content">
                <v-row dense v-if="filteredModels.length">
                  <v-col
                    v-for="(model, index) in filteredModels"
                    :key="index"
                    cols="12"
                    sm="4"
                    md="7"
                    lg="3"
                  >
                    <!-- Added click event on the card to open the ModelPopup -->
                    <v-card  class="pa-3" outlined tile @click="openModelPopup(model)">
                      <div class="viewer-container" >
                        <img
                          :src="`https://objaverse-thumbnail-images.s3.us-west-2.amazonaws.com/${model.id}.jpg`"
                          alt="Model Thumbnail"
                          class="thumbnail-img"
                        />
                      </div>
                      <v-divider></v-divider>
                      <div>
                        <p  class="title-center">{{ formatName(model.name) }}</p>
                      </div>

                    </v-card>

                  </v-col>
                </v-row>
                <v-row dense v-else>
                  <v-col cols="12">
                    <p class="coming-soon">No results found.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            
            <v-tab-item>
              <v-container class="main-content">
                <v-row dense v-if="filteredModels.length">
                  <v-col
                    v-for="(model, index) in filteredModels"
                    :key="index"
                    cols="12"
                    sm="4"
                    md="7"
                    lg="3"
                  >
                    <!-- Added click event on the card to open the ModelPopup -->
                    <v-card  class="pa-3" outlined tile @click="openModelPopup(model)">
                      <div class="viewer-container" >
                        <img
                          :src="`assets/shapenet/output/${model.id}.png`"
                          alt="Model Thumbnail"
                          class="thumbnail-img"
                        />
                      </div>
                      <v-divider></v-divider>
                      <div>
                        <p  class="title-center">{{ formatName(model.name) }}</p>
                      </div>

                    </v-card>

                  </v-col>
                </v-row>
                <v-row dense v-else>
                  <v-col cols="12">
                    <p class="coming-soon">No results found.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container class="main-content">
                <v-row dense v-if="filteredModels.length">
                  <v-col
                    v-for="(model, index) in filteredModels"
                    :key="index"
                    cols="12"
                    sm="4"
                    md="7"
                    lg="3"
                  >
                    <!-- Added click event on the card to open the ModelPopup -->
                    <v-card  class="pa-3" outlined tile @click="openModelPopup(model)">
                      <div class="viewer-container" >
                        <img
                          :src="`assets/PIX/output/${model.id}.png`"
                          alt="Model Thumbnail"
                          class="thumbnail-img"
                        />
                      </div>
                      <v-divider></v-divider>
                      <div>
                        <p  class="title-center">{{ model.name }}</p>
                      </div>

                    </v-card>

                  </v-col>
                </v-row>
                <v-row dense v-else>
                  <v-col cols="12">
                    <p class="coming-soon">No results found.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container class="main-content">
                <v-row dense v-if="filteredModels.length">
                  <v-col
                    v-for="(model, index) in filteredModels"
                    :key="index"
                    cols="12"
                    sm="4"
                    md="7"
                    lg="3"
                  >
                    <!-- Added click event on the card to open the ModelPopup -->
                    <v-card  class="pa-3" outlined tile @click="openModelPopup(model)">
                      <div class="viewer-container" >
                        <img
                          :src="`assets/Omni/output/${model.id}.png`"
                          alt="Model Thumbnail"
                          class="thumbnail-img"
                        />
                      </div>
                      <v-divider></v-divider>
                      <div>
                        <p  class="title-center">{{ formatName(model.name) }}</p>
                      </div>

                    </v-card>

                  </v-col>
                </v-row>
                <v-row dense v-else>
                  <v-col cols="12">
                    <p class="coming-soon">No results found.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container class="main-content">
                <v-row dense v-if="filteredModels.length">
                  <v-col
                    v-for="(model, index) in filteredModels"
                    :key="index"
                    cols="12"
                    sm="4"
                    md="7"
                    lg="3"
                  >
                    <!-- Added click event on the card to open the ModelPopup -->
                    <v-card  class="pa-3" outlined tile @click="openModelPopup(model)">
                      <div class="viewer-container" >
                        <img
                          :src="`assets/Toys/output/${model.id}.png`"
                          alt="Model Thumbnail"
                          class="thumbnail-img"
                        />
                      </div>
                      <v-divider></v-divider>
                      <div>
                        <p  class="title-center">{{ formatName(model.name) }}</p>
                      </div>

                    </v-card>

                  </v-col>
                </v-row>
                <v-row dense v-else>
                  <v-col cols="12">
                    <p class="coming-soon">No results found.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container class="main-content">
                <v-row dense v-if="filteredModels.length">
                  <v-col
                    v-for="(model, index) in filteredModels"
                    :key="index"
                    cols="12"
                    sm="4"
                    md="7"
                    lg="3"
                  >
                    <!-- Added click event on the card to open the ModelPopup -->
                    <v-card  class="pa-3" outlined tile @click="openModelPopup(model)">
                      <div class="viewer-container" >
                        <img
                          :src="`assets/GSO2/output/${model.id}.png`"
                          alt="Model Thumbnail"
                          class="thumbnail-img"
                        />
                      </div>
                      <v-divider></v-divider>
                      <div>
                        <p  class="title-center">{{ formatName(model.name) }}</p>
                      </div>

                    </v-card>

                  </v-col>
                </v-row>
                <v-row dense v-else>
                  <v-col cols="12">
                    <p class="coming-soon">No results found.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item>
              <v-container class="main-content">
                <v-row dense v-if="filteredModels.length">
                  <v-col
                    v-for="(model, index) in filteredModels"
                    :key="index"
                    cols="12"
                    sm="4"
                    md="7"
                    lg="3"
                  >
                    <!-- Added click event on the card to open the ModelPopup -->
                    <v-card  class="pa-3" outlined tile @click="openModelPopup(model)">
                      <div class="viewer-container" >
                        <img
                          :src="`assets/ABO/output/${model.id}.png`"
                          alt="Model Thumbnail"
                          class="thumbnail-img"
                        />
                      </div>
                      <v-divider></v-divider>
                      <div>
                        <p  class="title-center">{{ formatName(model.name) }}</p>
                      </div>

                    </v-card>

                  </v-col>
                </v-row>
                <v-row dense v-else>
                  <v-col cols="12">
                    <p class="coming-soon">No results found.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
      <!-- Popup Component -->
      <ModelPopup
        v-if="popupVisible"
        :visible="popupVisible"
        :modelData="selectedModel"
        :type="activeTab"
        @close="popupVisible = false"
      />
    </v-container>
  </v-container>
</template>

<script>
import { openDB } from "idb";
import ModelPopup from './Popup.vue';
import { db } from '../firebase';
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  startAt,
  endAt,
  where,
  documentId,
} from 'firebase/firestore';

export default {
  components: {
    ModelPopup,
  },
  data() {
    return {
      tabs: [
        { name: "Objaverse", models: [] },
        { name: "ShapeNet", models: [] },
        { name: "Pix3D", models: [] },
        { name: "OmniObject3D", models: [] },
        { name: "Toys4K", models: [] },
        { name: "GSO", models: [] },
        { name: "ABO", models: [] },
      ],
      activeTab: 0,
      searchQuery: "",
      loading: false,
      // LVIS categories from Firestore
      categories: [],
      lvisAnnotations: {}, // holds { categoryName: [filtered_ids] }
      selectedCategory: "",
      // Models to display (Firebase models for Objaverse and JSON data for others)
      filteredModels: [],
      // To store fetched Firebase models for Objaverse tab
      firebaseModels: [],
      popupVisible: false,
      selectedModel: null,
      // For JSON data in non‑Objaverse tabs (if needed)
      categoryData: null,
    };
  },
  computed: {
    currentTabName() {
      return this.tabs[this.activeTab]?.name || "";
    },
    formattedName() {
      return this.formatName(this.model.name);
    }
  },
  methods: {
    formatName(name) {
      if (!name) return "";
      return name
        .replace(/[_\W]+/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .replace(/\b\w/g, char => char.toUpperCase());
    },

    // --------------------------------------------
    // Firebase LVIS Annotations Methods
    async fetchLVISAnnotations() {
      try {
        const q = query(collection(db, "Indexing/Lvis_annotation/CategoryName"));
        const querySnapshot = await getDocs(q);
        const annotations = {};
        querySnapshot.forEach((doc) => {
          // Assumes each document's ID is the category name and contains a "filtered_ids" field
          annotations[doc.id] = doc.data().filtered_ids || [];
        });
        this.lvisAnnotations = annotations;
        this.categories = Object.keys(annotations);
        console.log("LVIS annotations loaded from Firebase:", this.lvisAnnotations);
      } catch (error) {
        console.error("Error fetching LVIS annotations from Firestore:", error);
      }
    },

    // --------------------------------------------
    // JSON & IndexedDB Methods (for non‑Objaverse tabs)
    async openDatabase() {
      return openDB("LargeJsonDB", 2, {
        upgrade(db) {
          if (!db.objectStoreNames.contains("jsonStore")) {
            db.createObjectStore("jsonStore");
          }
        },
      });
    },
    async clearIndexedDB() {
      try {
        const db = await this.openDatabase();
        const tx = db.transaction("jsonStore", "readwrite");
        await tx.objectStore("jsonStore").clear();
        await tx.done;
        console.log("IndexedDB cache cleared");
      } catch (error) {
        console.error("Error clearing IndexedDB:", error);
      }
    },
    async storeJsonInIndexedDB() {
      try {
        const response = await fetch("assets/lvis_annotations.json");
        const data = await response.json();
        const db = await this.openDatabase();
        const tx = db.transaction("jsonStore", "readwrite");
        await tx.objectStore("jsonStore").put(data, "jsonData");
        await tx.done;
        console.log("JSON stored in IndexedDB");
      } catch (error) {
        console.error("Error storing JSON:", error);
      }
    },
    async loadJsonFromIndexedDB() {
      try {
        const db = await this.openDatabase();
        const data = await db.transaction("jsonStore").objectStore("jsonStore").get("jsonData");
        if (data) {
          console.log("JSON loaded from IndexedDB");
          return data;
        } else {
          console.log("No data in IndexedDB, fetching from network...");
          await this.storeJsonInIndexedDB();
          return this.loadJsonFromIndexedDB();
        }
      } catch (error) {
        console.error("Error loading JSON from IndexedDB:", error);
        return null;
      }
    },
    applyJSONFilters() {
      let filtered = this.selectedCategory
        ? (this.categoryData ? (this.categoryData[this.selectedCategory] || []) : [])
        : (this.categoryData ? Object.values(this.categoryData).flat() : []);
      if (this.searchQuery.trim()) {
        const queryLower = this.searchQuery.toLowerCase();
        filtered = filtered.filter(item => item.toLowerCase().includes(queryLower));
      }
      // Use slice (e.g., 12 items) for non‑Objaverse tabs
      this.filteredModels = filtered.slice(0, 12);
    },

    // --------------------------------------------
    // Firebase Methods (for Objaverse tab)
    async fetchInitialFirebaseModels() {
      try {
        // Fetch initial 20 objects from Firestore using the "name" field
        console.log("Fetching initial models from Firestore..." , this.activeTab);
        var dataset = 'Marvel2.0';
        if (this.activeTab == 0){
          dataset = 'Marvel2.0';
        } else if (this.activeTab == 1){
          dataset = 'Shapenet1000';
        } else if (this.activeTab == 2){
          dataset = 'PIX3D';
        } else if (this.activeTab == 3){
          dataset = 'Omni';
        } else if (this.activeTab == 4){
          dataset = 'Toys4K';
        } else if (this.activeTab == 5){
          dataset = 'GSO';
        } else if (this.activeTab == 6){
          dataset = 'ABO';
        }
        const q = query(
          collection(db, dataset),
          limit(20)
        );
        const querySnapshot = await getDocs(q);
        const models = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          models.push({
            id: doc.id,
            name:  data.name == null || data.name == undefined ? data.base : data.name,
            level5: data.level_5 || "",
            level4: data.level_4 || "",
            level3: data.level_3 || "",
            level2: data.level_2 || "",
            level1: data.level_1 || ""
          });
        });
        this.firebaseModels = models;
        this.filteredModels = models;
        console.log("Fetched initial models from Firestore:", this.firebaseModels);
      } catch (error) {
        console.error("Error fetching initial models from Firestore:", error);
      }
    },
    async searchFirebaseModels() {
      try {
        var dataset = 'Marvel2.0';
        var order = 'base';
        console.log("Searching models in Firestore...", this.activeTab);  
        if (this.activeTab == 0){
          dataset = 'Marvel2.0';
          order = 'name';
        } else if (this.activeTab == 1){
          dataset = 'Shapenet1000';
        } else if (this.activeTab == 2){
          dataset = 'PIX3D';
        } else if (this.activeTab == 3){
          dataset = 'Omni';
        } else if (this.activeTab == 4){
          dataset = 'Toys4K';
        } else if (this.activeTab == 5){
          dataset = 'GSO';
        } else if (this.activeTab == 6){
          dataset = 'ABO';
        }
        const searchTerm = this.searchQuery.trim();
        if (!searchTerm) {
          await this.fetchInitialFirebaseModels();
          return;
        }
        // Note: Firestore range queries are case‑sensitive.
        const nameQuery = query(
          collection(db, dataset),
          orderBy(order),
          startAt(searchTerm),
          endAt(searchTerm + "\uf8ff"),
          limit(10)
        );
        const level5Query = query(
          collection(db, dataset),
          orderBy("level_5"),
          startAt(searchTerm),
          endAt(searchTerm + "\uf8ff"),
          limit(5)
        );
        const [nameSnapshot , level5Snapshot] = await Promise.all([
          getDocs(nameQuery),
          getDocs(level5Query)
        ]);
        // Merge results avoiding duplicates
        const modelsMap = new Map();
        nameSnapshot.forEach((doc) => {
          console.log(doc.data());
          const data = doc.data();
          modelsMap.set(doc.id, {
            id: doc.id,
            name:  data.name == null || data.name == undefined ? data.base : data.name,
            level5: data.level_5 || "",
            level4: data.level_4 || "",
            level3: data.level_3 || "",
            level2: data.level_2 || "",
            level1: data.level_1 || ""
          });
        });
        level5Snapshot.forEach((doc) => {
          if (!modelsMap.has(doc.id)) {
            const data = doc.data();
            modelsMap.set(doc.id, {
              id: doc.id,
              name: data.name,
              level5: data.level_5 || "",
              level4: data.level_4 || "",
              level3: data.level_3 || "",
              level2: data.level_2 || "",
              level1: data.level_1 || ""
            });
          }
        });
        this.firebaseModels = Array.from(modelsMap.values()).slice(0, 20);
        this.filteredModels = this.firebaseModels;
      } catch (error) {
        console.error("Error searching models in Firestore:", error);
      }
    },

    // New method to filter Objaverse models based on LVIS category
    async filterFirebaseModelsByLVISCategory(category) {
      try {
        const filteredIDs = this.lvisAnnotations[category] || [];
        if (!filteredIDs.length) {
          this.filteredModels = [];
          return;
        }
        // Firestore 'in' query supports up to 10 elements; adjust if needed.
        const queryIDs = filteredIDs.slice(0, 10);
        const q = query(
          collection(db, "Marvel2.0"),
          where(documentId(), "in", queryIDs)
        );
        const querySnapshot = await getDocs(q);
        const models = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          models.push({
            id: doc.id,
            name: data.name,
            level5: data.level_5 || "",
            level4: data.level_4 || "",
            level3: data.level_3 || "",
            level2: data.level_2 || "",
            level1: data.level_1 || ""
          });
        });
        this.filteredModels = models;
      } catch (error) {
        console.error("Error filtering models by LVIS category:", error);
      }
    },

    // Update category filtering to use Firebase for Objaverse
    filterByCategory(category) {
      this.selectedCategory = category;
      if (this.activeTab === 0) {
        // For Objaverse tab, filter using LVIS annotations from Firebase
        this.filterFirebaseModelsByLVISCategory(category);
      } else {
        // For other tabs, fallback to JSON filters (if applicable)
        this.applyJSONFilters();
      }
    },

    // --------------------------------------------
    // Apply Filters based on active tab and search query
    async applyFilters() {
      this.loading = true;

      // For Objaverse tab, use Firebase methods
      if (this.searchQuery.trim()) {
        await this.searchFirebaseModels();
      } else {
        await this.fetchInitialFirebaseModels();
      }

      this.loading = false;
    },

    // --------------------------------------------
    // Open the ModelPopup with the selected model
    openModelPopup(model) {
      console.log("Opening ModelPopup for model:", model);
      this.selectedModel = model;
      this.popupVisible = true;
    },
  },
  watch: {
    activeTab() {
      this.filteredModels = [];
      this.searchQuery = "";
      this.fetchInitialFirebaseModels();

    }
  },
  async mounted() {
    // Fetch LVIS annotations from Firebase for sidebar categories
    await this.fetchLVISAnnotations();
    // Optionally, if you still use JSON for non‑Objaverse tabs:
    if (this.activeTab !== 0) {
      await this.clearIndexedDB();
      const data = await this.loadJsonFromIndexedDB();
      if (data) {
        this.categoryData = data;
        if (!this.selectedCategory) {
          this.filteredModels = Object.values(data).flat().slice(0, 12);
        }
      }
    }
    // For Objaverse tab, fetch models from Firestore
    await this.fetchInitialFirebaseModels();
    
  },
};
</script>

<style scoped>
/* Sidebar Styles */
.main-content {
  height: 100vh;
  overflow-y: auto;
}
.category-box {
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  background: linear-gradient(#3c4ae605, #e7303005);
}
.sidebar-title {
  text-align: center;
  font-weight: 500;
  color: #274690;
  padding-top: 10px;
}
.divider {
  border: none;
  height: 1px;
  background-color: #56638A;
}
.category-container {
  height: 100vh;
  overflow-y: auto;
  padding-right: 10px;
  margin-top: 10px;
}
.category-text {
  display: block;
  cursor: pointer;
  font-size: 14px;
  margin-bottom: 8px;
  color: #555;
  padding-left: 10px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
}
.category-text:hover {
  text-decoration: underline;
  color: #007BFF;
}
.selected-category {
  font-weight: bold;
  color: #007BFF;
}

/* Main Content & Tab Styles */
.tabs-container {
  margin-bottom: 20px;
}
.page-title {
  margin: 0;
}
.thumbnail-img {
  width: 100%;
  height: 300px;
  object-fit: cover;
}
.gradient-text {
  font-weight: bold;
  font-size: 2rem;
  background: linear-gradient(to right, #007bff, #9168df, #b65c6c, #da9462);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
}
.caption-text {
  font-size: 0.9rem;
  color: #555;
  margin-top: 4px;
}
.coming-soon {
  text-align: center;
  margin-top: 20px;
  font-size: 1.2rem;
}
.title-center {
  text-align: center;
  font-size: 1.2rem;
}
</style>
